import { useRef } from 'react';
import { DismissButton, Overlay, usePopover } from 'react-aria';

import styles from './PopoverOverlay.module.scss';

const PopoverOverlay = ({ children, state, offset = 8, ...props }) => {
    const popoverRef = useRef();
    const { popoverProps, underlayProps, arrowProps, placement } = usePopover({
        ...props,
        offset,
        popoverRef
    }, state);

    return (
        <Overlay>
            <div {...underlayProps} className={styles.underlay} />
            <div
                {...popoverProps}
                ref={popoverRef}
                className={styles.popover}
            >
                <svg {...arrowProps} className={styles.arrow} data-placement={placement}>
                    <path d="M0 0,L6 6,L12 0" />
                </svg>
                {children}
                <DismissButton onDismiss={state.close} />
            </div>
        </Overlay>
    );
};

export default PopoverOverlay;
